import { Base64 } from 'js-base64';
export function getAuthorisationHeader(clientId, clientSecret) {
    return 'Basic ' + Base64.encode("".concat(clientId, ":").concat(clientSecret));
}
